import axios from 'axios';
import Url from '../constants/Url';

class TaxProfileApi {
    getOrganizations() {
        return axios
            .get(Url().GET_ORGANIZATIONS)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to get organization', ex.message);
                throw ex;
            });
    }

    getTaxInterviewURL(data) {
        return axios
            .post(Url().GET_TAX_INTERVIEW, data)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get tax interview', ex.message);
                throw ex;
            });
    }

    getTaxRecord() {
        return axios
            .get(Url().GET_TAX_RECORD)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get tax record', ex.message);
                throw ex;
            });
    }

    getRecordEmail(organizationId) {
        return axios
            .get(Url().GET_RECORD_EMAIL, {params: {organizationId}})
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get record email', ex.message);
                throw ex;
            });
    }

    getBalancePayable() {
        return axios
            .get(Url().GET_BALANCE_PAYABLE)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get balance payable', ex.message);
                throw ex;
            });
    }

    getConsent() {
        return axios
            .get(Url().GET_CONSENT)
            .then(resp => resp.data)
            .catch(ex => {
                console.error('Failed to get payment consent', ex.message);
                throw ex;
            });
    }

    retakeInterview(data) {
        return axios
            .post(Url().RETAKE_INTERVIEW, data)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to retakeInterview:', ex.message);
                throw ex;
            });
    }

    refreshTaxRecord() {
        return axios
           .post(Url().REFRESH_TAX_RECORD, {})
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to refresh tax record', ex.message);
                throw ex;
            });
    }

    getUpdateAvailable(params) {
        return axios
            .get(Url().GET_UPDATE_AVAILABLE, {params})
            .then(response => response.data)
            .catch(ex => {
               console.error('Failed to get retake available');
               throw ex;
            });
    }

    consentForPayment(data) {
        return axios
            .post(Url().CONSENT_FOR_PAYMENT, data)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to consent url');
                throw ex;
            });
    }

    updateTaxRecord(data) {
        return axios
            .post(Url().UPDATE_TAX_RECORD, data)
            .then(response => response.data)
            .catch(ex => {
                console.error('Failed to updateTaxRecord');
                throw ex;
            });
    }
}

export default new TaxProfileApi();
